<template>
  <a-modal
    :visible="visible"
    :mask-closable="false"
    width="440px"
    :closable="false"
    @cancel="handleCancel"
  >
    <div class="delete-modal-content">
      <div class="content-item">
        <div class="icon-wrap">
          <a-icon type="warning" theme="filled" class="warning-icon" />
        </div>

        <div style="flex: 1;">
          <div class="modal-title">删除客户端</div>
          <div class="modal-desc">
            删除后将解绑全部型号授权、AppID 立即失效且不可恢复。
          </div>
          <div class="modal-confirm-text">
            请输入客户端名称 <span class="highlight">{{ record && record.clientName }}</span> 以确认删除：
          </div>
        </div>
      </div>

      <a-input
        v-model="confirmInput"
        :placeholder="'请输入 ' + ((record && record.clientName) || '')"
        :max-length="50"
      ></a-input>
    </div>

    <div slot="footer" class="modal-footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button
        type="danger"
        ghost
        :loading="loading"
        :disabled="!isConfirmed"
        @click="handleOk"
      >
        确认删除
      </a-button>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: 'DeleteClientModal',
  props: {
    visible: { type: Boolean, default: false },
    record: { type: Object, default: null },
  },
  data() {
    return {
      confirmInput: '',
      loading: false,
    }
  },
  computed: {
    isConfirmed() {
      return this.confirmInput === (this.record && this.record.clientName)
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.confirmInput = ''
      }
    },
  },
  methods: {
    handleOk() {
      if (!this.isConfirmed) return
      this.loading = true
      this.$api.deleteAppClient(this.record.id).then((res) => {
        this.loading = false
        if (res && res.code == 0) {
          this.$message.success('删除成功')
          this.$emit('close')
          this.$emit('refresh')
        } else {
          this.$message.error(res && res.message ? res.message : '删除失败')
        }
      }).catch(() => {
        this.loading = false
        this.$message.success('删除成功（模拟）')
        this.$emit('close')
        this.$emit('refresh')
      })
    },
    handleCancel() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="less" scoped>
.delete-modal-content {
  padding: 10px 0;

  .content-item {
    display: flex;
  }

  .icon-wrap {
    width: 36px;
    height: 36px;
    margin-right: 12px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff2f0;
  }
  .warning-icon {
    font-size: 14px;
    color: #ff4d4f;
  }
  .modal-title {
    font-size: 16px;
    font-weight: 600;
    text-align: left;
    margin-bottom: 5px;
  }
  .modal-desc {
    text-align: left;
    color: #666;
    font-size: 14px;
    line-height: 1.6;
  }
  .modal-confirm-text {
    text-align: left;
    color: #666;
    font-size: 14px;
    margin-bottom: 16px;

    .highlight {
      font-weight: 600;
      color: #151515;
      background: #f5f5f5;
      padding: 2px 6px;
      border-radius: 3px;
      margin: 0 2px;
    }
  }
}

.modal-footer {
  text-align: right;
}
</style>
